import * as React from "react"
export const Svg_040 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M8.066 10.69h3.457v3.457H8.066V10.69Z" />
    <path
      fill="url(#b)"
      d="M43.79 14.147V4.928H14.98v9.219h-3.457v39.925h35.954V14.147h-3.688ZM28.84 32.38h1.32a5.27 5.27 0 0 1 5.263 5.264 5.273 5.273 0 0 1-4.195 5.154v2.31h-3.457v-2.24a4.815 4.815 0 0 1-4.195-4.768h3.457c0 .744.606 1.35 1.351 1.35h1.776c.996 0 1.807-.81 1.807-1.806 0-.997-.811-1.807-1.807-1.807h-1.32a5.27 5.27 0 0 1-5.264-5.264 5.273 5.273 0 0 1 4.195-5.155v-2.308h3.457v2.238a4.815 4.815 0 0 1 4.195 4.769h-3.457c0-.745-.605-1.35-1.35-1.35H28.84c-.996 0-1.807.81-1.807 1.806s.811 1.807 1.807 1.807Zm11.492-18.234H18.437V8.385h21.895v5.762Z"
    />
    <path fill="url(#c)" d="M50.934 14.147H59v39.925h-8.066V14.147Z" />
    <path fill="url(#d)" d="M47.477 10.69h3.457v3.457h-3.457V10.69Z" />
    <path fill="url(#e)" d="M0 14.147h8.066v39.925H0V14.147Z" />
    <defs>
      <linearGradient
        id="a"
        x1={8.866}
        x2={10.508}
        y1={11.208}
        y2={13.866}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={19.838}
        x2={45.571}
        y1={12.3}
        y2={42.769}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={52.799}
        x2={65.327}
        y1={20.136}
        y2={24.232}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={48.276}
        x2={49.918}
        y1={11.208}
        y2={13.866}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={1.865}
        x2={14.393}
        y1={20.136}
        y2={24.232}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)